import { useEffect } from 'react';
import { deferUntilNewTitle } from '@moda/portal-stanchions';
import { tc } from '../lib/trackingContext';
import { useCart } from './useCart';

export const useBagVisitTracking = (ignore = false) => {
  const { cart, loaded: cartLoaded } = useCart();

  useEffect(() => {
    if (!ignore && cartLoaded) {
      deferUntilNewTitle(() => {
        tc.track('Cart Viewed', {
          addToScopeOnce: { cart, products: cart.attributes.cartItems.map(item => item.data) }
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartLoaded]);
};
